<div class="card card-custom gutter-b card-strech">
    <ngx-work-notes [pet_no]="pet_no" [client_no]="client_no"></ngx-work-notes>
</div>